/* eslint-disable */
import React from "react";
import {
  Flex,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

const VERSION = "2.1.7-PROD 20260318";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const linkColor = useColorModeValue({ base: "gray.400", lg: "white" }, "white");

  return (
    <Flex
      zIndex="3"
      flexDirection={{
        base: "column",
        lg: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px={{ base: "30px", md: "0px" }}
      pb="30px"
    >
      <Flex
        flexDirection="column"
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", lg: "0px" }}
      >
        <Text>
          &copy; {1900 + new Date().getYear()}{" "}
          Toko Kopi Tuku. All Rights Reserved. Made with love by{" "}
          <Link
            mx="3px"
            color={textColor}
            href="https://www.miraisolusi.com"
            target="_blank"
            fontWeight="700"
          >
            Mirai
          </Link>
        </Text>

        <Text
          fontSize="sm"
          fontWeight="500"
        >
          Version {VERSION}
        </Text>
      </Flex>
    </Flex>
  );
}
